module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-parking-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Parking Group Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _c('label', [_vm._v("Vat"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vat_id),
      expression: "vat_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vat_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select custom vat")]), _vm._l((_vm.vats), function(vat) {
    return _c('option', {
      domProps: {
        "value": vat.id
      }
    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
  })], 2)])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Booking Mode")]), _c('BookingModeSelect', {
    model: {
      value: (_vm.reservation_type),
      callback: function($$v) {
        _vm.reservation_type = $$v
      },
      expression: "reservation_type"
    }
  })], 1)]), _c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "button",
    class: {
      disabled: !_vm.name || !_vm.reservation_type
    },
    on: {
      "click": _vm.createParkingGroup
    }
  }, [_vm._v("Add")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ba81fc2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CreateParkingGroup.vue
// module id = 2227
// module chunks = 1